export default __webpack_public_path__ + "static/media/49t.4bdc0702.jpg";